import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

// ITP 360 LLC company details for W9
const ITP_INFO = {
  name: 'ITP 360 LLC',
  taxClassification: 'LLC (C corporation election)',
  address: '4380 SW 74 Ave',
  cityStateZip: 'Miami, FL 33155',
  einPrefix: '88',
  einSuffix: '3405228',
  signerName: 'Xavier Garnicas',
};

// W9 form field name constants (IRS Form W-9 Rev. Oct 2018+)
const FIELDS = {
  name: 'topmostSubform[0].Page1[0].f1_01[0]',
  businessName: 'topmostSubform[0].Page1[0].f1_02[0]',
  llcCheckbox: 'topmostSubform[0].Page1[0].Boxes3a-b_ReadOrder[0].c1_1[5]',
  llcClassification: 'topmostSubform[0].Page1[0].Boxes3a-b_ReadOrder[0].f1_03[0]',
  address: 'topmostSubform[0].Page1[0].Address_ReadOrder[0].f1_07[0]',
  cityStateZip: 'topmostSubform[0].Page1[0].Address_ReadOrder[0].f1_08[0]',
  einPrefix: 'topmostSubform[0].Page1[0].f1_14[0]',
  einSuffix: 'topmostSubform[0].Page1[0].f1_15[0]',
};

export async function generateW9PDF(): Promise<Uint8Array> {
  const templateUrl = `${process.env.PUBLIC_URL}/templates/fw9.pdf`;
  const templateBytes = await fetch(templateUrl).then((res) => {
    if (!res.ok) throw new Error('Failed to load W9 template');
    return res.arrayBuffer();
  });

  const pdfDoc = await PDFDocument.load(templateBytes, {
    ignoreEncryption: true,
  });
  const form = pdfDoc.getForm();

  // Fill company name
  form.getTextField(FIELDS.name).setText(ITP_INFO.name);

  // Check LLC checkbox and enter the tax classification: C = C corporation
  // (ITP 360 LLC is an LLC that elected C-corp taxation, per IRS W-9 line 3 instructions)
  form.getCheckBox(FIELDS.llcCheckbox).check();
  form.getTextField(FIELDS.llcClassification).setText('C');

  // Fill address
  form.getTextField(FIELDS.address).setText(ITP_INFO.address);
  form.getTextField(FIELDS.cityStateZip).setText(ITP_INFO.cityStateZip);

  // Fill EIN (split into two fields: XX and XXXXXXX)
  form.getTextField(FIELDS.einPrefix).setText(ITP_INFO.einPrefix);
  form.getTextField(FIELDS.einSuffix).setText(ITP_INFO.einSuffix);

  // Draw signature and date on the certification section
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const font = await pdfDoc.embedFont(StandardFonts.TimesRomanItalic);

  // "Sign Here" row: "Signature of U.S. person" label at y≈205, box top at y≈247
  // Place signature on the line inside the box, just above the label
  firstPage.drawText(ITP_INFO.signerName, {
    x: 120,
    y: 202,
    size: 12,
    font,
    color: rgb(0, 0, 0.5),
  });

  // Date in the "Date" box (right side of Sign Here row)
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const year = today.getFullYear();
  const dateStr = `${month}/${day}/${year}`;

  firstPage.drawText(dateStr, {
    x: 420,
    y: 202,
    size: 10,
    font,
    color: rgb(0, 0, 0.5),
  });

  // Flatten form fields so the PDF is read-only
  form.flatten();

  return pdfDoc.save();
}
